import React, { useState } from 'react';
import {Row, Col, Button} from 'reactstrap';
import AssistConfigBaseTable from '../../components/tables/AssistConfigBaseTable/AssistConfigBaseTable';
import CreateNewConfigForm from '../../components/forms/CreateNewConfigForm';
import ModalComponent from '../../components/modal/ModalComponent';

const AssistConfig = () => {
	const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
	const [needToUpdate, setNeedToUpdate] = useState(true);
	
	return (
		<div className="container-fluid content settings extension">
			<Row className="page-title align-items-center">
				<Col sm={8}>
					<div className="d-flex align-items-center mr-5">
						<span className="card-title mb-4">Notification Configuration</span>
					</div>
					<div className="d-flex align-items-center mr-5">
						<span className="card-subtitle mb-3">Configure where and when AI assistance will be offered to users</span>
					</div>
					<div className="d-flex align-items-center mr-5">
						<span className="card-subtitle mb-0">Set up rules to determine when users see AI support pop-ups based on the pages they visit.</span>
					</div>
				</Col>
        <Col sm="4">
          <div className="page-actions d-flex flex-column align-items-end">
            <Button
              className="button button-default"
							onClick={() => setIsCreateModalOpen(true)}
            >
              + Add Notification Rule
            </Button>
          </div>
        </Col>
			</Row>
			<div className="table-responsive">
				<AssistConfigBaseTable
					needToUpdate={needToUpdate}
					setNeedToUpdate={setNeedToUpdate}
				/>
			</div>

			{isCreateModalOpen && (
				<ModalComponent
					isModalOpen={isCreateModalOpen}
					modalHeaderTitle="AI Notification Trigger"
					toggleModal={() => setIsCreateModalOpen(!isCreateModalOpen)}
					isModalFooter={false}
				>
					<CreateNewConfigForm
						closeModal={() => setIsCreateModalOpen(false)}
						updateData={() => setNeedToUpdate(true)}
					/>
				</ModalComponent>
			)}
		</div>
	);
};

export default AssistConfig;
